import {
    i18n,
} from '@/plugins/vuei8n'

const localState = {
    servicesData: [],
    services: [],
    servicesAll: [],
    service: '',
    servicesPriority: [],
    serviceSelfData: {
        color: '',
        description: '',
        title: '',
        is_active: true,
        office_prices: [],
    },
    newServiceForm: {
        is_active: false,
        office_prices: [],
    },
    formDataServiceIcon: null,
    formDataServiceSmallIcon: null,
    error: false,

    deleteModal: false,
    serviceModal: false,
    deleteId: '',
    isEdit: false,
    deletion_tag: false,
}

const actions = {
    async getServices({
        state,
        commit,
    }) {
        try {
            const response = await this.$api.services.fetch()

            if (response.status !== 200) return

            state.servicesData = response.data.data
            commit('selectServicesData', response.data.data)
            commit('selectServicesDataAll', response.data.data)
        } catch (err) {
            console.log(err)
        }
    },
    async getServiceData({
        commit,
    }, id) {
        try {
            const response = await this.$api.services.fetchById(id)

            commit('setServiceSelfData', response.data.data)
            // console.log(response.data.data);
            // state.serviceSelfData = response.data.data;
        } catch (err) {
            console.log(err)
        }
    },
    async addService({
        state,
        dispatch,
        commit,
    }) {
        try {
            commit('serviceForm', state.serviceSelfData)
            const response = await this.$api.services.create(state.newServiceForm)

            await dispatch('updateServiceIcon', {
                id: response.data.data.id,
                data: state.formDataServiceIcon,
            })

            await dispatch('updateServiceSmallIcon', {
                id: response.data.data.id,
                data: state.formDataServiceSmallIcon,
            })
            await dispatch('getServices')

            commit('emptyServiceData')
            commit('setServiceModal')
        } catch (err) {
            console.log(err)
        }
    },
    async editService({
        state,
        dispatch,
        commit,
    }, id) {
        try {
            commit('serviceForm', state.serviceSelfData)
            await this.$api.services.update(id, state.newServiceForm)

            if (state.formDataServiceIcon) {
                await dispatch('updateServiceIcon', {
                    id,
                    data: state.formDataServiceIcon,
                })
            }

            if (state.formDataServiceSmallIcon) {
                await dispatch('updateServiceSmallIcon', {
                    id,
                    data: state.formDataServiceSmallIcon,
                })
            }

            await dispatch('getServices')
            commit('setServiceModal')
        } catch (err) {
            console.log(err)
        }
    },
    async deleteService({
        state,
        dispatch,
        commit,
    }) {
        try {
            await this.$api.services.remove(state.deleteId)
            dispatch('getServices')
            commit('setDeleteModal')
        } catch (err) {
            console.log(err)
        }
    },
    async requestForDeleteService({
        state,
        dispatch,
    }, id) {
        try {
            const deleteId = state.deleteId || id

            await this.$api.services.requestForDelete(deleteId)
            await dispatch('getServices')
        } catch (err) {
            console.log(err)
        }
    },
    async updateServiceIcon(_, {
        id,
        data,
    }) {
        try {
            if (id) {
                await this.$api.services.updateIcon(id, data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async updateServiceSmallIcon(_, {
        id,
        data,
    }) {
        try {
            if (id) {
                await this.$api.services.updateSmallIcon(id, data)
            }
        } catch (err) {
            console.log(err)
        }
    },
    async updateServiceAnimation(_, {
        id,
        data,
    }) {
        try {
            if (id) {
                const response = await this.$api.services.updateAnimation(id, data)
                return response.status === 200
            }
        } catch (err) {
            console.log(err)
        }
    },
}

const mutations = {
    setState(state, {
        type,
        data,
    }) {
        state[type] = data
    },
    selectServicesData(state, data) {
        state.services = []
        data.forEach((element) => {
            const option = {
                text: element.title,
                id: element.id,
                is_active: element.is_active,
                color: element.color,
                slug: element.slug,
            }
            state.services.push(option)
        })
    },
    selectServicesDataAll(state, data) {
        state.servicesAll = []
        data.forEach((element) => {
            const option = {
                text: element.title,
                id: element.id,
                is_active: element.is_active,
            }
            state.servicesAll.push(option)
        })

        if (state.servicesAll[0].id !== 'all') {
            state.servicesAll.unshift({
                text: i18n.t('listsHeader.all'),
                id: 'all',
                is_active: false,
            })
        }
    },
    updateOrderServices(state, data) {
        state.servicesData = data
    },
    emptyServiceData(state) {
    // for (const key in state.serviceSelfData) {
    //   if (key === "is_active") {
    //     state.serviceSelfData[key] = false;
    //     continue;
    //   }

        //   state.serviceSelfData[key] = "";
        // }
        state.serviceSelfData = {
            color: '',
            description: '',
            title: '',
            is_active: true,
            office_prices: [],
        }

        state.formDataServiceSmallIcon = null
        state.formDataServiceIcon = null
    },
    serviceForm(state, data) {
        state.newServiceForm = {
            color: data.color,
            description: data.description,
            // price: data.price,
            title: data.title,
            is_active: data.is_active,
            slug: data.slug,
            // price_fifteen: parseInt(data.price_fifteen),
            // percent_extra_price_1: data.percent_extra_price_1,
            // percent_extra_price_2: data.percent_extra_price_2,
            office_prices: data.office_prices,
        }
    },
    servicesErrorUpdate(state, value) {
        state.error = value
    },
    setDeleteModal: (state) => {
        state.deleteModal = !state.deleteModal
    },
    setServiceModal: (state) => {
        state.serviceModal = !state.serviceModal
    },
    setDeleteId: (state, v) => {
        state.deleteId = v
    },
    setEdit: (state, v) => {
        state.isEdit = v
    },
    setService: (state, v) => {
        state.service = v
    },
    setServiceIcon: (state, v) => {
        state.formDataServiceIcon = v
    },
    setServiceSmallIcon: (state, v) => {
        state.formDataServiceSmallIcon = v
    },
    setServicesDeletionStatus: (state, v) => {
        state.deletion_tag = v
    },
    setServiceSelfData: (state, v) => {
        state.serviceSelfData = {
            ...v,
        }

        state.serviceSelfData.office_prices = state.serviceSelfData.office_prices.map((item) => ({
            office_id: item.id,
            address: item.address,
            ...item.prices,
        }))
    },
}

const getters = {
    serviceSelfData: (state) => state.serviceSelfData,
    servicesGetters: (state) => state.services,
    servicesGettersWithAll: (state) => state.servicesAll,
    serviceGetters: (state) => state.service,
    deleteModalGetters: (state) => state.deleteModal,
    serviceModalGetters: (state) => state.serviceModal,
    servicesFullData: (state) => state.servicesData,
    isEditGetters: (state) => state.isEdit,
    servicesDeleteId: (state) => state.deleteId,
    servicesDeletionStatusGetters: (state) => state.deletion_tag,
    formDataServiceIconGetters: (state) => state.formDataServiceIcon,
    formDataServiceSmallIconGetters: (state) => state.formDataServiceSmallIcon,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
